function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var videoBoxTemplate = require('./video-box.template');
var SaitoVideoBox = /*#__PURE__*/function () {
  function SaitoVideoBox(app, mod, peer) {
    var _this = this;
    var container_class = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    _classCallCheck(this, SaitoVideoBox);
    this.app = app;
    this.mod = mod;
    this.stream = null;
    this.stream_id = peer;
    this.containerClass = container_class;
    this.peer_list = [];
    this.video_class = '';
    this.display_wave_form = false;

    //
    // Handlers are kept by reference so destroy() can unhook them from the
    // global emitter -- otherwise dead boxes keep reacting to events forever
    //
    this.listeners = {};
    this.addListener('peer-toggle-transcription-status', function (_ref) {
      var public_key = _ref.public_key;
      var key = _this.stream_id === 'local' ? _this.mod.publicKey : _this.stream_id;
      if (public_key === key) _this.renderTranscriptionStatus();
    });
    this.addListener('peer-toggle-audio-status', function (_ref2) {
      var enabled = _ref2.enabled,
        public_key = _ref2.public_key;
      if (public_key !== _this.stream_id) return;

      //console.debug('Videobox.peer-toggle-audio-status', public_key, enabled);

      var icon = document.querySelector("#stream_".concat(_this.stream_id, " #audio-indicator"));
      if (icon) {
        if (enabled) {
          icon.classList.remove('fa-microphone-slash');
          icon.classList.add('fa-microphone');
          icon.classList.remove('disabled');
          _this.attachAudioEvents();
        } else {
          icon.classList.add('fa-microphone-slash');
          icon.classList.remove('fa-microphone');

          //Cut out the fuzzing
          if (_this.animation) {
            window.cancelAnimationFrame(_this.animation);
            _this.animation = null;
          }
          icon.removeAttribute('style');
        }
      }
    });
    this.addListener('peer-toggle-video-status', function (_ref3) {
      var enabled = _ref3.enabled,
        public_key = _ref3.public_key;
      if (public_key !== _this.stream_id) return;

      //console.debug('Videobox.peer-toggle-video-status', public_key, enabled);

      _this.toggleMask(enabled);
    });
    this.addListener('stun-update-connection-message', function (peer_id, status) {
      if (_this.stream_id !== peer_id) {
        return;
      }
      if (status === 'connecting') {
        _this.updateConnectionMessage('connecting');
      } else if (status === 'connected') {
        _this.removeConnectionMessage();
      } else if (status === 'disconnected') {
        _this.updateConnectionMessage('retrying connection');
      }
    });
    this.addListener('peer-list', function (address, list) {
      if (address !== _this.stream_id) {
        return;
      }

      //Save the list in case we change the video display and re-render
      _this.peer_list = list;
      _this.renderPeerList();
    });
  }
  return _createClass(SaitoVideoBox, [{
    key: "addListener",
    value: function addListener(event, handler) {
      this.listeners[event] = handler;
      this.app.connection.on(event, handler);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      for (var event in this.listeners) {
        this.app.connection.removeListener(event, this.listeners[event]);
      }
      this.listeners = {};
      this.remove();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var stream = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (stream) {
        this.stream = stream;
      }

      //console.debug(`Videobox.render: [${this.stream_id}]`, stream);

      var videoBox = document.getElementById("stream_".concat(this.stream_id));

      //Add Video Box
      if (!videoBox) {
        this.app.browser.addElementToClass(videoBoxTemplate(this.stream_id, this.app, this.mod, this.video_class), this.containerClass);
        videoBox = document.getElementById("stream_".concat(this.stream_id));
        var videoBoxVideo = document.querySelector("#stream_".concat(this.stream_id, " video"));
        videoBoxVideo.addEventListener('play', function (event) {
          _this2.app.connection.emit('video-box-started', _this2.stream_id);
          console.debug('Videobox: ', _this2.stream_id + ' Begin Playing Video:', event.currentTarget.videoWidth, event.currentTarget.videoHeight);
          if (event.currentTarget.videoHeight > event.currentTarget.videoWidth) {
            console.debug('Videobox: Portrait Video!');
            event.currentTarget.parentElement.classList.add('portrait');
          } else {
            console.debug('Videobox: Landscape Video!');
            event.currentTarget.parentElement.classList.remove('portrait');
          }
        });
      } else if (this.containerClass) {
        //
        // Reconcile placement: move the live element rather than rebuilding it,
        // so the <video> keeps playing without flashing black
        //
        var target = document.querySelector(".video-container-large .".concat(this.containerClass));
        if (target && videoBox.parentElement !== target) {
          target.appendChild(videoBox);
        }
      }
      if (this.stream) {
        var _this$stream$getVideo, _this$stream$getAudio;
        this.removeConnectionMessage();
        var _videoBoxVideo = document.querySelector("#stream_".concat(this.stream_id, " video"));

        //
        // Re-assigning the same MediaStream restarts playback, so only touch
        // srcObject when the stream actually changed
        //
        if (_videoBoxVideo.srcObject !== this.stream) {
          _videoBoxVideo.srcObject = this.stream;
        }
        if (((_this$stream$getVideo = this.stream.getVideoTracks()) === null || _this$stream$getVideo === void 0 ? void 0 : _this$stream$getVideo.length) > 0) {
          //steam includes video, as it should
        } else {
          if (this.display_wave_form) {
            this.renderWave();
          } else {
            //add message saying NOT to expect video
            this.updateConnectionMessage('No video feed', false);
            this.toggleMask(true);
          }
        }
        if (((_this$stream$getAudio = this.stream.getAudioTracks()) === null || _this$stream$getAudio === void 0 ? void 0 : _this$stream$getAudio.length) > 0) {
          //
          // track.enabled/.muted on a remote track reflect transport-level state
          // (e.g. transient jitter dropouts), not the peer's actual mute preference.
          // The real mute state comes from the 'toggle-audio' signaling message, so
          // only derive it from the raw track here for streams we control ourselves --
          // otherwise this can race with and overwrite the correct remote mute icon.
          //
          if (this.stream_id === 'local' || this.stream_id === 'presentation') {
            var enabled = this.stream_id === 'presentation' ? true : this.stream.getAudioTracks()[0].enabled && !this.stream.getAudioTracks()[0].muted;
            this.app.connection.emit('peer-toggle-audio-status', {
              enabled: enabled,
              public_key: this.stream_id
            });
          }
        } else {
          var icon = document.querySelector("#stream_".concat(this.stream_id, " #audio-indicator"));
          icon.classList.add('disabled');
        }
      } else {
        this.updateConnectionMessage();
      }
      this.renderPeerList();
      this.renderTranscriptionStatus();
      this.attachEvents();
    }
  }, {
    key: "renderTranscriptionStatus",
    value: function renderTranscriptionStatus() {
      var _document$getElementB, _this$mod$streams;
      var key = this.stream_id === 'local' ? this.mod.publicKey : this.stream_id;
      var notice = (_document$getElementB = document.getElementById("stream_".concat(this.stream_id))) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.querySelector('.peer-transcription-status');
      if (notice) notice.hidden = !((_this$mod$streams = this.mod.streams) !== null && _this$mod$streams !== void 0 && (_this$mod$streams = _this$mod$streams.transcribingPeers) !== null && _this$mod$streams !== void 0 && _this$mod$streams.has(key));
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this3 = this;
      var volumeControl = document.querySelector("#stream_".concat(this.stream_id, " .volume-control i"));
      var videoBoxVideo = document.querySelector("#stream_".concat(this.stream_id, " video"));
      if (volumeControl && videoBoxVideo) {
        volumeControl.onclick = function () {
          var audioTrack = _this3.stream.getAudioTracks()[0];
          if (audioTrack) {
            if (audioTrack.enabled) {
              audioTrack.enabled = false;
              volumeControl.classList.remove('fa-volume-up');
              volumeControl.classList.add('fa-volume-mute');
            } else {
              audioTrack.enabled = true;
              volumeControl.classList.remove('fa-volume-mute');
              volumeControl.classList.add('fa-volume-up');
            }
          }
        };
      }
    }
  }, {
    key: "show",
    value: function show() {
      var v_box = document.getElementById("stream_".concat(this.stream_id));
      if (v_box) {
        v_box.classList.remove('hidden');
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      var v_box = document.getElementById("stream_".concat(this.stream_id));
      if (v_box) {
        v_box.classList.add('hidden');
      }
    }
  }, {
    key: "rerender",
    value: function rerender() {
      this.render(this.stream);
      this.renderPeerList();
    }
  }, {
    key: "renderPeerList",
    value: function renderPeerList() {
      if (this.stream_id === 'local') return;
      var callList = document.querySelector(".video-call-info[data-id=\"".concat(this.stream_id, "\"] .peer-call-list"));
      if (!callList) {
        console.error('Videobox: Call list element not found for the given key:', this.stream_id);
        return;
      }
      callList.innerHTML = '';
      for (var address in this.peer_list) {
        //
        // I already know the state of my own connection with this peer,
        // only show their connections with the other call members
        //
        if (address === this.mod.publicKey) {
          continue;
        }
        var connectionState = this.peer_list[address];
        var identiconUrl = this.app.keychain.returnIdenticon(address);
        var img = document.createElement('img');
        img.src = identiconUrl;
        img.alt = "Identicon for ".concat(address);
        img.classList.add('peer-list-item');
        if (connectionState !== 'connected') {
          img.classList.add('not-connected');
        }
        img.classList.add('saito-identicon');
        img.setAttribute('data-id', address);
        callList.appendChild(img);
      }
    }
  }, {
    key: "addConnectionStrength",
    value: function addConnectionStrength(strength) {
      if (this.stream_id === 'local') return;
      var callList = document.querySelector(".video-call-info[data-id=\"".concat(this.stream_id, "\"] .peer-call-list"));
      if (!callList) {
        console.error('Videobox: Call list element not found for the given key:', this.stream_id);
        return;
      }
      if (!document.querySelector(".video-call-info[data-id=\"".concat(this.stream_id, "\"] .peer-call-list .connection-strength"))) {
        var html = "<div class=\"connection-strength\" title=\"connection strength\">\n                    <div class=\"bar one-bar\"></div>\n                    <div class=\"bar two-bar\"></div>\n                    <div class=\"bar three-bar\"></div>\n                    <div class=\"bar four-bar\"></div>\n                    </div>";
        this.app.browser.addElementToDom(html, callList);
      }
      var elem = document.querySelector(".video-call-info[data-id=\"".concat(this.stream_id, "\"] .peer-call-list .connection-strength"));
      if (!elem) {
        console.error('Videobox: Connection strength element not found for the given key:', this.stream_id);
      }
      elem.dataset.strength = strength;
    }
  }, {
    key: "attachAudioEvents",
    value: function attachAudioEvents() {
      var _this$stream$getVideo2,
        _this4 = this;
      if (this.animation || !this.stream) {
        return;
      }
      if (((_this$stream$getVideo2 = this.stream.getVideoTracks()) === null || _this$stream$getVideo2 === void 0 ? void 0 : _this$stream$getVideo2.length) > 0 || !this.display_wave_form) {
        var icon = document.querySelector("#stream_".concat(this.stream_id, " #audio-indicator"));
        var audioContext = new AudioContext();
        var track = audioContext.createMediaStreamSource(this.stream);
        var analyser = audioContext.createAnalyser();
        analyser.fftSize = 256;

        // Build Audio Chain
        track.connect(analyser);
        var bufferLength = analyser.frequencyBinCount;
        var dataArray = new Uint8Array(bufferLength);
        var _onFrame = function onFrame() {
          analyser.getByteFrequencyData(dataArray);
          var sumSquares = 0;
          var _iterator = _createForOfIteratorHelper(dataArray),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var amplitude = _step.value;
              sumSquares += amplitude * amplitude;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          var raw = Math.sqrt(sumSquares / dataArray.length);

          // I think these max out at 255
          // so with a little Spinal Tap scaling, we have a percentage of the max
          //

          var num = Math.round(200 * raw / 255) / 10;
          num = Math.min(15, num);
          var blur = Math.ceil(num / 5);
          icon.style.boxShadow = "0 0 ".concat(blur, "px ").concat(num, "px var(--saito-primary)");
          _this4.animation = window.requestAnimationFrame(_onFrame);
        };
        this.animation = window.requestAnimationFrame(_onFrame);
      }
    }
  }, {
    key: "renderWave",
    value: function renderWave() {
      var _this$stream$getVideo3;
      if (this.animation) {
        window.cancelAnimationFrame(this.animation);
        this.animation = null;
      }
      if (!((_this$stream$getVideo3 = this.stream.getVideoTracks()) !== null && _this$stream$getVideo3 !== void 0 && _this$stream$getVideo3.length) && this.display_wave_form) {
        var _drawOscilloscope = function drawOscilloscope() {
          //Update date time domain data
          analyser.getFloatTimeDomainData(waveform);

          //Draw Canvas
          canvasContext.clearRect(0, 0, oscCanvas.width, oscCanvas.height);
          canvasContext.beginPath();
          var gradient = canvasContext.createLinearGradient(0, 0, 300, 0);
          gradient.addColorStop('0', 'magenta');
          gradient.addColorStop('0.66', 'blue');
          gradient.addColorStop('1.0', 'red');
          canvasContext.strokeStyle = gradient;
          canvasContext.lineWidth = 2;
          for (var i = 0; i < waveform.length; i++) {
            var x = i;
            var y = (0.5 + waveform[i] / 2) * oscCanvas.height;
            if (i === 0) {
              canvasContext.moveTo(x, y);
            } else {
              canvasContext.lineTo(x, y);
            }
          }
          canvasContext.stroke();
          this.animation = requestAnimationFrame(_drawOscilloscope);
        };
        var audioElement = document.getElementById(this.stream_id);
        var audioContext = new AudioContext();
        var masterGain = audioContext.createGain();
        var analyser = audioContext.createAnalyser();
        if (!document.getElementById('oscilloscope')) {
          this.app.browser.addElementToId("<canvas id=\"oscilloscope\"></canvas>", "stream_".concat(this.stream_id));
        }
        var tracks = this.stream.getAudioTracks();
        if (tracks.length == 1) {
          var track = audioContext.createMediaStreamSource(this.stream);
          track.connect(masterGain).connect(analyser);
        } else {
          tracks.forEach(function (track) {
            var temp = new MediaStream([track]);
            audioContext.createMediaStreamSource(temp).connect(masterGain).connect(analyser);
          });
        }

        /*
         * The Web Audio API provides the AnalyserNode for this purpose.
         * In addition to providing the raw waveform (aka time domain) data,
         * it provides methods for accessing the audio spectrum (aka frequency domain) data.
         *
         * At this point, the waveform array will contain values from -1 to 1 corresponding to the audio waveform playing
         * through the masterGain node. This is just a snapshot of whatever’s currently playing.
         * */

        var waveform = new Float32Array(analyser.frequencyBinCount);
        analyser.getFloatTimeDomainData(waveform);

        // Setup canvas
        var oscCanvas = document.getElementById('oscilloscope');
        oscCanvas.width = waveform.length / 2;
        oscCanvas.height = 200;
        var canvasContext = oscCanvas.getContext('2d');
        _drawOscilloscope();
      }
    }
  }, {
    key: "updateConnectionMessage",
    value: function updateConnectionMessage() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'negotiating peer connection';
      var with_icon = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var video_box = document.getElementById("stream_".concat(this.stream_id));
      var icon = with_icon ? "<span class=\"lds-dual-ring\"></span>" : '';
      if (video_box.querySelector('#connection-message')) {
        video_box.querySelector('#connection-message').innerHTML = "<p>".concat(message, "</p>").concat(icon);
      } else {
        video_box.insertAdjacentHTML('beforeend', "<div id=\"connection-message\"> <p>".concat(message, "</p>").concat(icon, "</div> "));
      }
    }
  }, {
    key: "removeConnectionMessage",
    value: function removeConnectionMessage() {
      var video_box = document.getElementById("stream_".concat(this.stream_id));
      if (video_box && video_box.querySelector('#connection-message')) {
        video_box.querySelector('#connection-message').remove();
      }
    }
  }, {
    key: "toggleMask",
    value: function toggleMask(enabled) {
      try {
        var elem = document.querySelector("#stream_".concat(this.stream_id, " .default-video-mask"));
        if (enabled) {
          elem.classList.add('hidden');
        } else {
          elem.classList.remove('hidden');
        }
      } catch (err) {
        console.error('Videobox.toggleMask Error: ', err);
      }
    }
  }, {
    key: "remove",
    value: function remove() {
      var is_disconnection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      //Cut out the fuzzing
      if (this.animation) {
        window.cancelAnimationFrame(this.animation);
        this.animation = null;
      }
      var videoBox = document.getElementById("stream_".concat(this.stream_id));
      if (videoBox) {
        if (videoBox._bg_observer) {
          videoBox._bg_observer.disconnect();
        }
        videoBox.remove();
      }
    }
  }]);
}();
module.exports = SaitoVideoBox;